/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Button } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

interface IRequestInvoiceButtonProps {
    innerReference?: React.RefObject<HTMLButtonElement>;
    className: string;
    requestInvoiceButtonLabel: string;
    onClicked(): void;

}

export const RequestInvoiceButton: React.FC<IRequestInvoiceButtonProps> = ({ className, onClicked, requestInvoiceButtonLabel, innerReference }) => {
    return (
        <Button className={`${className}__requestInvoiceButton`} onClick={onClicked} innerRef={innerReference}>
            {requestInvoiceButtonLabel}
        </Button>
    );
};
